import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  clearIntervalAsync,
  setIntervalAsync,
} from 'set-interval-async/dynamic'
// import BetPlacing from "../../BetPlacing/BetPlacing";
import CardsInfo from '../helpers/CardsInfo/CardsInfo'
import { GET_INPLAY_POPULAR_INTERVAL } from '../../../config/app.config'
import LastResults from '../helpers/LastResults/LastResults'
import { connectSevenUpDown } from './SevenUpDown.connect'
import * as img from './SevenUpDownHelpers/helpers'
import './SevenUpDown.scss'

const SevenUpDown = ({
  sportEvent,
  betPlacing,
  actions,
  exchangeGames,
  exposure,
  activeTab,
  headerHeight,
  auth,
  elementsParams,
}) => {
  const dataOdd = sportEvent.sportData
  const { eventId } = useParams()

  // window width
  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth
  // end window width

  //get price
  const getMarketPrice = (marketIndex, runnersIndex, side = 'back') => {
    if (
      dataOdd &&
      dataOdd[marketIndex] &&
      dataOdd[marketIndex].runners[runnersIndex] &&
      dataOdd[marketIndex].runners[runnersIndex][side][0] &&
      dataOdd[marketIndex].runners[runnersIndex][side][0].price
    ) {
      return dataOdd[marketIndex].runners[runnersIndex][side][0].price
    }
  }
  //end get price
  // get exposure
  const getExposure = (marketIndex, runnerIndex) => {
    if (auth) {
      const id =
        sportEvent.sportData[marketIndex] &&
        sportEvent.sportData[marketIndex].runners[runnerIndex] &&
        sportEvent.sportData[marketIndex].runners[runnerIndex].id
      let objFinder =
        exposure?.pnlBySelection[
          Object.keys(exposure?.pnlBySelection).filter((item) =>
            item.includes(id)
          )
        ]?.pnl
      // let objFinder = 200;
      if (objFinder) {
        return (
          <div
            className={
              objFinder > 0
                ? 'seven-up-down-exposure-box-modern seven-up-down-exposure-modern--pos'
                : 'seven-up-down-exposure-box-modern seven-up-down-exposure-modern--neg'
            }
          >
            {objFinder}
          </div>
        )
      }
    } else return
  }
  // end get exposure
  // Show betslip
  // const renderBetPlacing = () => {
  //     if (betPlacing.runner && width < 1024) {
  //         return <BetPlacing headerHeight={headerHeight} />;
  //     }
  //     return null;
  // };
  // End Show betslip
  // Bet placing
  const select = (dataOdd, item, isBack) => {
    const runner = { name: item.name, id: item.id }
    const oddData = isBack
      ? { ...item.back[0], runner }
      : { ...item.lay[0], runner }
    const marketId = dataOdd && dataOdd.id
    const runnerId = oddData && oddData.runner && oddData.runner.id
    if (!marketId || !runnerId) return
    actions.setMarket(marketId)
    actions.setRunner(runnerId)
    actions.setRunnerName(oddData && oddData.runner && oddData.runner.name)
    actions.setEventName(dataOdd && dataOdd.event && dataOdd.event.name)
    actions.setIsBack(isBack)
    actions.setPrice(oddData && oddData.price)
    actions.setPriceActual(oddData && oddData.price)
    actions.setDelay(dataOdd && dataOdd.betDelay)
    actions.setMtype(dataOdd && dataOdd.mtype)
    actions.setBtype(dataOdd && dataOdd.btype)
    actions.setLine(oddData && oddData.line)
    actions.setFromOneClick(false)
    actions.setStake(null)

    actions
      .requestBetPlacingStart(marketId, runnerId)
      .then((response) => {})
      .catch((err) => console.error('err = ', err))
  }
  const oddPush = (marketIndex, runnerIndex, isBack = true) => {
    return dataOdd[marketIndex].isBettable
      ? select(
          dataOdd[marketIndex],
          dataOdd[marketIndex]?.runners[runnerIndex],
          isBack
        )
      : null
  }
  // End Bet placing
  // lock market
  const resultStatus = (marketIndex, runner) => {
    if (
      exchangeGames &&
      exchangeGames[marketIndex]?.marketRunner[runner]?.status === 'WINNER'
    ) {
      return 'lock-ui winner'
    }
    // return  "lock-ui winner "
    return !dataOdd[marketIndex].isBettable && 'lock-ui'
  }
  // end lock market

  useEffect(() => {
    actions.requestExchangeGames(eventId).then()
    const timer = setIntervalAsync(async () => {
      await actions
        .requestExchangeGames(eventId)
        .catch((e) => console.error('requestInplayPopular error = ', e))
    }, GET_INPLAY_POPULAR_INTERVAL)
    return () => clearIntervalAsync(timer)
  }, [])

  return (
    <>
      <CardsInfo />
      <div
        className={`seven-up-down ${eventId === '98793' ? 'virtual' : ''} ${
          activeTab === 0 ? 'fullHeight' : ''
        }`}
      >
        <div className="seven-up-down-table">
          {width < 1024 ? (
            <div className="seven-up-down-table__players-wrapper">
              {/* {renderBetPlacing()} */}
              <div className="seven-up-down-table__players-group-first mob">
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards ${resultStatus(
                    0,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(0, 0)
                  }}
                >
                  <img src={img.up7} alt="sevenUp" />
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(0, 0)}
                    </span>
                    <div>{getExposure(0, 0)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards sec  ${resultStatus(
                    0,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(0, 1)
                  }}
                >
                  <img src={img.seven} alt="seven" />
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(0, 1)}{' '}
                    </span>
                    <div>{getExposure(0, 1)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards thr   ${resultStatus(
                    0,
                    2
                  )}`}
                  onClick={() => {
                    oddPush(0, 2)
                  }}
                >
                  <img src={img.down7} alt="sevenDown" />
                  <div className="seven-up-down-table__player-price">
                    <div className="seven-up-down-table__player-price-text">
                      {getMarketPrice(0, 2)}
                    </div>
                    <div>{getExposure(0, 2)}</div>
                  </div>
                </div>
              </div>
              <div className="seven-up-down-table__players-group-second mob">
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors ${resultStatus(
                    1,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(1, 1)
                  }}
                >
                  <div className="seven-up-down-table__player-images color">
                    <img src={img.spades} alt="spades" />
                    <img src={img.clubs} alt="clubs" />
                  </div>
                  <div className="seven-up-down-table__player-price">
                    {getMarketPrice(1, 1)}
                    <div>{getExposure(1, 1)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors ${resultStatus(
                    1,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(1, 0)
                  }}
                >
                  <div className="seven-up-down-table__player-images color">
                    <img src={img.hearts} alt="hearts" />
                    <img src={img.diamonds} alt="diamonds" />
                  </div>
                  <div className="seven-up-down-table__player-price">
                    {getMarketPrice(1, 0)}
                    <div>{getExposure(1, 0)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors-text  ${resultStatus(
                    2,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(2, 1)
                  }}
                >
                  <div className="seven-up-down-table__player-images">EVEN</div>
                  <div className="seven-up-down-table__player-price">
                    {getMarketPrice(2, 1)}
                    <div>{getExposure(2, 1)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors-text ${resultStatus(
                    2,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(2, 0)
                  }}
                >
                  <div className="seven-up-down-table__player-images">ODD</div>
                  <div className="seven-up-down-table__player-price">
                    {getMarketPrice(2, 0)}
                    <div>{getExposure(2, 0)}</div>
                  </div>
                </div>
              </div>
              <div className="seven-up-down-table__players-group-second mob">
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors  ${resultStatus(
                    3,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(3, 0)
                  }}
                >
                  <span className="seven-up-down-table__player-images">
                    <img src={img.clubs} alt="clubs" />
                  </span>
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(3, 0)}
                    </span>
                    <div>{getExposure(3, 0)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors ${resultStatus(
                    3,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(3, 1)
                  }}
                >
                  <span className="seven-up-down-table__player-images">
                    <img src={img.diamonds} alt="diamonds" />
                  </span>
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(3, 1)}{' '}
                    </span>
                    <div>{getExposure(3, 1)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors ${resultStatus(
                    3,
                    3
                  )}`}
                  onClick={() => {
                    oddPush(3, 3)
                  }}
                >
                  <span className="seven-up-down-table__player-images">
                    <img src={img.spades} alt="spades" />
                  </span>
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(3, 3)}
                    </span>
                    <div>{getExposure(3, 3)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors ${resultStatus(
                    3,
                    2
                  )}`}
                  onClick={() => {
                    oddPush(3, 2)
                  }}
                >
                  <span className="seven-up-down-table__player-images">
                    <img src={img.hearts} alt="hearts" />
                  </span>
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(3, 2)}{' '}
                    </span>
                    <div>{getExposure(3, 2)}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="seven-up-down-table__players-wrapper">
              <div className="seven-up-down-table__players-group-first">
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards ${resultStatus(
                    0,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(0, 0)
                  }}
                >
                  <img src={img.up7} alt="sevenUp" />
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(0, 0)}
                    </span>
                    <div>{getExposure(0, 0)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards ${resultStatus(
                    0,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(0, 1)
                  }}
                >
                  <img src={img.seven} alt="seven" />
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(0, 1)}{' '}
                    </span>
                    <div>{getExposure(0, 1)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards ${resultStatus(
                    0,
                    2
                  )}`}
                  onClick={() => {
                    oddPush(0, 2)
                  }}
                >
                  <img src={img.down7} alt="sevenDown" />
                  <div className="seven-up-down-table__player-price">
                    <div className="seven-up-down-table__player-price-text">
                      {getMarketPrice(0, 2)}
                    </div>
                    <div>{getExposure(0, 2)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors ${resultStatus(
                    1,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(1, 1)
                  }}
                >
                  <div className="seven-up-down-table__player-images">
                    <img src={img.spades} alt="spades" />
                    <img src={img.clubs} alt="clubs" />
                  </div>
                  <div className="seven-up-down-table__player-price">
                    {getMarketPrice(1, 1)}
                    <div>{getExposure(1, 1)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors ${resultStatus(
                    1,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(1, 0)
                  }}
                >
                  <div className="seven-up-down-table__player-images">
                    <img src={img.hearts} alt="hearts" />
                    <img src={img.diamonds} alt="diamonds" />
                  </div>
                  <div className="seven-up-down-table__player-price">
                    {getMarketPrice(1, 0)}
                    <div>{getExposure(1, 0)}</div>
                  </div>
                </div>
              </div>
              <div className="seven-up-down-table__players-group-second">
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors-text  ${resultStatus(
                    2,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(2, 1)
                  }}
                >
                  <div className="seven-up-down-table__player-images">EVEN</div>
                  <div className="seven-up-down-table__player-price">
                    {getMarketPrice(2, 1)}
                    <div>{getExposure(2, 1)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-colors-text ${resultStatus(
                    2,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(2, 0)
                  }}
                >
                  <div className="seven-up-down-table__player-images">ODD</div>
                  <div className="seven-up-down-table__player-price">
                    {getMarketPrice(2, 0)}
                    <div>{getExposure(2, 0)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards  ${resultStatus(
                    3,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(3, 0)
                  }}
                >
                  <span className="seven-up-down-table__player-images">
                    <img src={img.clubs} alt="clubs" />
                  </span>
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(3, 0)}
                    </span>
                    <div>{getExposure(3, 0)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards ${resultStatus(
                    3,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(3, 1)
                  }}
                >
                  <span className="seven-up-down-table__player-images">
                    <img src={img.diamonds} alt="diamonds" />
                  </span>
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(3, 1)}{' '}
                    </span>
                    <div>{getExposure(3, 1)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards ${resultStatus(
                    3,
                    3
                  )}`}
                  onClick={() => {
                    oddPush(3, 3)
                  }}
                >
                  <span className="seven-up-down-table__player-images">
                    <img src={img.spades} alt="spades" />
                  </span>
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(3, 3)}
                    </span>
                    <div>{getExposure(3, 3)}</div>
                  </div>
                </div>
                <div
                  className={`seven-up-down-table__player seven-up-down-table__player-cards ${resultStatus(
                    3,
                    2
                  )}`}
                  onClick={() => {
                    oddPush(3, 2)
                  }}
                >
                  <span className="seven-up-down-table__player-images">
                    <img src={img.hearts} alt="hearts" />
                  </span>
                  <div className="seven-up-down-table__player-price">
                    <span className="seven-up-down-table__player-price-text">
                      {getMarketPrice(3, 2)}{' '}
                    </span>
                    <div>{getExposure(3, 2)}</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <LastResults />
      </div>
    </>
  )
}

export default connectSevenUpDown()(SevenUpDown)
